import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-request-issuance',
  templateUrl: './request-issuance.component.html',
  styleUrls: ['./request-issuance.component.scss']
})
export class RequestIssuanceComponent implements OnInit {

  @Input() documentData: any;
  @Input() isFrom: any;
  @Input() selectedDocList: any = [];
  @Output() closePopup = new EventEmitter<boolean>();
  @Output() submitRequest = new EventEmitter<any>();

  // --- Logic Variables ---
  mainOption: 'DOWNLOAD' | 'PRINT' | null = null;
  subOption: 'DOC_REQ' | 'ORIGINAL' | 'REV_HIST' | null = null;

  // Data Lists
  templateList: any[] = [];
  verifierList: any[] = [];
  departmentList: any[] = [];
  documentIssuanceTypeDropdown: any[] = [];
  reportLogoDropdown: any[] = [];
  documentIssuanceTypeList: any[] = [];

  // Form Fields - New
  selectedTemplate: any;
  selectedVerifier: any;
  requestReason: string = '';
  selectedDepartment: any;

  // Form Fields - Common/Original
  documentIssuanceType: any;
  issuanceTo: any;
  issuanceCopy: number;
  issuanceReason: any;
  documentWatermark: any;
  watermarkColor: any = '#000000';
  documentNameForDownload: any;
  comments: any;
  selectedReportLogoValue: any;

  // Includes
  incudeCoverPgae: boolean = false;
  incudeCoverPgaeTitle: any;

  incudeAmendment: boolean = false;
  incudeAmendmentTitle: any;

  incudeApproval: boolean = false;
  incudeApprovalTitle: any;

  incudeRevisionhistory: boolean = false;
  incudeRevisionhistoryTitle: any;

  incudeFooter: boolean = false;
  incudePageNo: boolean = false;
  publisherDetails: boolean = false;
  linkedDocuments: boolean = false;

  incudeNotes: boolean = false;
  incudeNotesTitle: any;

  // Layout Logic
  onLastPage: boolean = false;
  isShowOnLatestTopDisabled: boolean = false;

  // History Logic
  completeHistory: boolean = false;
  historyYear: number | null = null;
  isLatestOnTop: boolean = true;

  // Search/Helpers
  issuanceTypeSearchText: string = '';
  verifierSearchText: string = '';
  departmentSearchText: string = '';
  pdfDetailSearchText: string = '';
  isProcessing: boolean = false;
  folderId = 0;
  typeDmsDocumentsVw: any;
  typeDmsDocumentsVwaterMark: any;
  dropDownDataForReportLogo: any;
  organizationReportImageDetails: any = {};
  imageIdList: any = [];

  constructor(private appService: AppService, private snackBar: MatSnackBar, public dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.isFrom == "BULK") {
      this.folderId = this.selectedDocList[0].folderId;
    } else {
      this.folderId = this.documentData.folderId;
    }

    this.fetchNewFieldDropdowns();
    this.fetchReportLogos();
    this.fetchDownloadTemplates();
  }

  // --- 1. Selection Changes ---

  onMainOptionChange(event: MatRadioChange) {
    this.subOption = null;
    this.resetForm();
  }

  onSubOptionChange(event: MatRadioChange) {
    this.resetForm();

    if (this.subOption === 'REV_HIST') {
      this.completeHistory = true;
      this.historyYear = null;
      this.isLatestOnTop = false;
    }

    if (this.subOption === 'DOC_REQ') {
      this.loadIssuanceTypes();
      this.completeHistory = true;
      this.historyYear = null;
      this.isLatestOnTop = false;
    }
  }

  // --- Auto-Fill Logic ---
  onTemplateSelect(event: any) {
    const selectedId = event.value;
    const templateData = this.templateList.find(t => t.id === selectedId)?.fullData;

    if (templateData) {
      console.log("Auto-filling form with template data:", templateData);

      // 1. Text & Number Fields
      this.issuanceTo = templateData.issuedTo || '';
      this.issuanceReason = templateData.issuanceReason || '';
      this.issuanceCopy = templateData.printsTaken;
      this.incudeNotesTitle = templateData.notesDetail || '';
      this.documentNameForDownload = templateData.templateName || '';

      // 2. Boolean Checkboxes
      this.incudeCoverPgae = templateData.coverPageOrSign === 'Y';
      this.incudeAmendment = templateData.amendment === 'Y';
      this.incudeApproval = templateData.approval === 'Y';
      this.incudeRevisionhistory = templateData.revisionHistory === 'Y';
      this.incudeFooter = templateData.footer === 'Y';
      this.incudePageNo = templateData.pageNumber === 'Y';
      this.publisherDetails = templateData.publisherDetails === 'Y';
      this.linkedDocuments = templateData.linkedDocuments === 'Y';
      this.incudeNotes = templateData.notes === 'Y';

      // Map Titles
      this.incudeCoverPgaeTitle = templateData.coverPageOrSignPageName;
      this.incudeAmendmentTitle = templateData.amendmentPageName;
      this.incudeApprovalTitle = templateData.approvalPageName;
      this.incudeRevisionhistoryTitle = templateData.revisionHistoryPageName;

      // 3. Logic Side Effects
      if (this.incudeCoverPgae) {
        this.onLastPage = true;
        this.isShowOnLatestTopDisabled = true;
      } else if (this.incudeApproval) {
        this.onLastPage = true;
        this.isShowOnLatestTopDisabled = false;
      } else {
        this.onLastPage = templateData.onLastPage === 'Y';
        this.isShowOnLatestTopDisabled = false;
      }
    }
  }

  fetchDownloadTemplates() {

    this.appService.getAllDownloadTemplates().subscribe(
      (data: any) => {
        this.templateList = data.map((item: any) => {
          return {
            id: item.templateId,
            name: item.templateName,
            fullData: item
          };
        });
      },
      (error) => {
        console.error("Error fetching templates:", error);
      }
    );
  }

  resetForm() {
    this.selectedTemplate = null;
    this.selectedVerifier = null;
    this.requestReason = '';
    this.selectedDepartment = null;
    this.documentIssuanceType = null;
    this.documentWatermark = '';
    this.documentNameForDownload = '';
    this.comments = '';
    this.completeHistory = false;
    this.historyYear = null;
    this.incudeCoverPgae = false;
    this.onLastPage = false;
    this.isShowOnLatestTopDisabled = false;
    this.incudeAmendment = false;
    this.incudeApproval = false;
    this.incudeRevisionhistory = false;
    this.incudeFooter = false;
    this.incudePageNo = false;
    this.publisherDetails = false;
    this.linkedDocuments = false;
    this.incudeNotes = false;

    // Clear titles
    this.incudeCoverPgaeTitle = null;
    this.incudeAmendmentTitle = null;
    this.incudeApprovalTitle = null;
    this.incudeRevisionhistoryTitle = null;
    this.incudeNotesTitle = null;
  }

  toggleChanged(event: MatCheckboxChange) {
    this.incudeCoverPgae = event.checked;
    if (this.incudeCoverPgae) {
      this.onLastPage = true;
      this.isShowOnLatestTopDisabled = true;
    } else {
      this.isShowOnLatestTopDisabled = false;
    }
  }

  onApprovalToggleChanged(event: MatCheckboxChange) {
    if (event.checked) {
      this.onLastPage = true;
    }
  }

  validateYear(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-' || event.key === '.') {
      event.preventDefault();
    }
  }

  // --- 3. Submission ---

  onSubmit() {
    if (!this.validateForm()) return;

    this.isProcessing = true;

    let payload = {

      documentId: this.documentData?.documentId,
      version: this.documentData?.version,

      requestType: this.mainOption,
      subRequestType: this.subOption,

      templateId: this.selectedTemplate,
      verifier: this.selectedVerifier,
      department: this.selectedDepartment,
      reasonForRequest: this.requestReason,

      watermark: this.documentWatermark,
      watermarkColor: this.watermarkColor,
      comments: this.comments,
      downloadDocumentName: this.documentNameForDownload,
      reportLogoId: this.selectedReportLogoValue,

      ...this.getScenarioFields()
    };

    // Emit OR Call Service
    this.appService.createDmsIssuanceRequest(payload).subscribe(
      (response: any) => {
        this.isProcessing = false;
        if (response.resultType === 'SUCCESS' || response.resultType === 'S') {
          this.snackBar.open(response.result || "Request Submitted Successfully", "OK", { duration: 3000, panelClass: 'Success' });
          this.submitRequest.emit(payload);
          this.closePopup.emit(true);
        } else {
          this.snackBar.open(response.result || "Failed to submit request", "OK", { duration: 3000, panelClass: 'Error' });
        }
      },
      (error) => {
        this.isProcessing = false;
        console.error("Error submitting request", error);
        this.snackBar.open("Server Error Occurred", "OK", { duration: 3000, panelClass: 'Error' });
      }
    );
  }

  getScenarioFields() {
    // --- HELPER FUNCTION FOR PLACEHOLDER LOGIC ---
    const getValueOrDefault = (isChecked: boolean, value: any, placeholder: string) => {
      if (isChecked && (!value || value.toString().trim() === '')) {
        return placeholder;
      }
      return value;
    };

    if (this.subOption === 'DOC_REQ') {
      return {
        issuanceType: this.documentIssuanceType,
        issuedTo: this.issuanceTo,
        printsTaken: this.issuanceCopy,
        issuanceReason: this.issuanceReason,

        // Apply Logic here
        coverPageOrSign: this.incudeCoverPgae ? 'Y' : 'N',
        coverPageOrSignPageName: getValueOrDefault(this.incudeCoverPgae, this.incudeCoverPgaeTitle, 'Cover Page'),

        amendment: this.incudeAmendment ? 'Y' : 'N',
        amendmentPageName: getValueOrDefault(this.incudeAmendment, this.incudeAmendmentTitle, 'Amendment'),

        approval: this.incudeApproval ? 'Y' : 'N',
        approvalPageName: getValueOrDefault(this.incudeApproval, this.incudeApprovalTitle, 'Approval'),

        revisionHistory: this.incudeRevisionhistory ? 'Y' : 'N',
        revisionHistoryPageName: getValueOrDefault(this.incudeRevisionhistory, this.incudeRevisionhistoryTitle, 'Revision History'),

        onLastPage: this.onLastPage ? 'Y' : 'N',
        footer: this.incudeFooter ? 'Y' : 'N',
        pageNumber: this.incudePageNo ? 'Y' : 'N',
        publisherDetails: this.publisherDetails ? 'Y' : 'N',
        linkedDocuments: this.linkedDocuments ? 'Y' : 'N',

        notes: this.incudeNotes ? 'Y' : 'N',
        notesDetail: getValueOrDefault(this.incudeNotes, this.incudeNotesTitle, 'Notes')
      };
    }
    else if (this.subOption === 'REV_HIST') {
      return {
        completeHistory: this.completeHistory ? 'Y' : 'N',
        historyYear: this.historyYear,
        isLatestOnTop: this.isLatestOnTop ? 'Y' : 'N'
      };
    }
    return {};
  }

  validateForm(): boolean {
    if (!this.selectedVerifier || !this.selectedDepartment || !this.requestReason) {
      this.snackBar.open("Please fill all mandatory fields (Verifier, Reason, Dept).", "Ok", { duration: 3000, panelClass: 'Error' });
      return false;
    }
    if (this.subOption === 'DOC_REQ' && !this.selectedTemplate) {
      this.snackBar.open("Please select a Template.", "Ok", { duration: 3000, panelClass: 'Error' });
      return false;
    }
    return true;
  }

  cancel() {
    this.closePopup.emit(true);
  }

  // --- API Calls ---

  loadIssuanceTypes() {
    this.isProcessing = true;
    this.typeDmsDocumentsVw = {

      documentId: this.isFrom == "BULK" ? this.selectedDocList[0].documentId : this.documentData.documentId,
      version: this.isFrom == "BULK" ? this.selectedDocList[0].version : this.documentData.version,
    };

    this.appService.getDocumentType(this.typeDmsDocumentsVw).subscribe((responsedata: any) => {
      this.isProcessing = false;
      this.documentIssuanceTypeDropdown = [];
      this.documentIssuanceTypeList = responsedata;
      for (let i = 0; i < this.documentIssuanceTypeList.length; i++) {
        this.documentIssuanceTypeDropdown.push({
          valueExp: this.documentIssuanceTypeList[i],
          displayExp: this.documentIssuanceTypeList[i]
        });
      }
    }, error => this.isProcessing = false);
  }

  documentIssuanceSelect(event: any, item: any) {
    if (event.isUserInput && item) {
      this.documentIssuanceType = item.valueExp;
      if (this.isFrom != "BULK") {
        this.callWatermark();
      }
    }
  }

  callWatermark() {
    this.typeDmsDocumentsVwaterMark = {

      documentId: this.documentData.documentId,
      version: this.documentData.version,
      printParentDetails: "Y",
      documentTypeCode: this.documentIssuanceType,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy
    };

    this.appService.getDocumentWatermark(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.documentWatermark = response.result;
    });
  }

  fetchReportLogos() {
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe((data: any) => {
      this.organizationReportImageDetails = data;
      this.appService.getQmsReportLogoByModuleAndGroupId("DOCS", this.folderId).subscribe((data: any) => {
        this.dropDownDataForReportLogo = data;
        this.selectBoxForReportLogo();
      });
      this.isProcessing = false;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown.push({ valueExp: 0, displayExp: 'Default' });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown.push({ valueExp: 0, displayExp: 'Default' });
          } else {
            for (let j = 0; j < this.organizationReportImageDetails.length; j++) {
              if (this.organizationReportImageDetails[j].reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown.push({
                  valueExp: this.organizationReportImageDetails[j].reportImageId,
                  displayExp: this.organizationReportImageDetails[j].reportImageName
                });
              }
            }
          }
        }
      } else {
        for (let j = 0; j < this.organizationReportImageDetails.length; j++) {
          if (this.organizationReportImageDetails[j].reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown.push({
              valueExp: this.organizationReportImageDetails[j].reportImageId,
              displayExp: this.organizationReportImageDetails[j].reportImageName
            });
          }
        }
      }
      if (this.reportLogoDropdown.length > 0)
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
    }
  }

  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedReportLogoValue = item.valueExp;
    }
  }

  fetchNewFieldDropdowns() {
    this.verifierList = [{ id: 101, name: 'John Doe' }, { id: 102, name: 'Jane Smith' }];
    const storedDepartments = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '[]');

    this.departmentList = [];

    if (Array.isArray(storedDepartments)) {

      this.departmentList = storedDepartments.map((dept: any) => ({
        id: dept.codelistCode,
        name: dept.codelistName
      }));
    }
  }

  focusSearch(id: string) { setTimeout(() => document.getElementById(id)?.focus(), 0); }
}